/**
 * main.js — the page script for every layout EXCEPT the article page.
 * Referenced by project/app/View/Layouts/head/head.ctp.
 *
 * Bundled by build/js.js into a classic IIFE at _v2/js/main.min.js. It is a
 * module here and a plain script there; nothing about how the layouts load it
 * changed.
 *
 * Every feature goes through mod(), so one failure cannot take the rest of the
 * page with it. See lib/module.js for why that matters more than it sounds.
 */
import { mod, ready } from './lib/module.js';
import { setupTheme } from './lib/theme.js';
import { setupDrawer } from './lib/drawer.js';
import { setupSearch } from './lib/search.js';
import { setupSearchPage } from './lib/search-page.js';
import { setupReveal } from './lib/reveal.js';
import { setupHero } from './lib/hero.js';
import { setupFrontB } from './lib/front-b.js';
import { setupEditions } from './lib/editions.js';
import { setupVideoRail } from './lib/video-rail.js';
import { setupResponsiveTables } from './lib/tables.js';
import { setupPoll } from './lib/poll.js';
import { setupContactForms } from './lib/contact.js';

// Before paint, and independent of the DOM: the attribute goes on <html>,
// which exists as soon as this runs. Waiting for DOMContentLoaded here would
// flash the wrong palette.
mod('theme', setupTheme);

ready(() => {
  mod('drawer', setupDrawer);
  mod('search', setupSearch);
  mod('search-page', setupSearchPage);
  mod('hero', setupHero);
  mod('front-b', setupFrontB);
  mod('editions', setupEditions);
  mod('video-rail', setupVideoRail);
  mod('reveal', setupReveal);
  mod('tables', setupResponsiveTables);
  mod('poll', setupPoll);
  mod('contact', setupContactForms);
});
